import { wrapImageOverlayer } from './OverLayer';
import { toolTypes } from '../../constants';

export default {
  type: 'selectAreaTool',
  setup: async ({ app }) => {
    app.extension.registerElementTool({
      name: toolTypes.selectAreaTool.name,
      label: '',
      preventCanvasUndoRedo: true,
    });

    app.extension.wrapElement('image', {
      overlayer: wrapImageOverlayer,
    });
  },
};
